// Shared shell style tokens (class strings / style objects) — kept apart from
// ui.jsx so that file exports components only (react-refresh).
export const card = 'rounded-2xl border bg-white'
export const cardStyle = { borderColor: 'var(--ns-hair-soft)', boxShadow: '0 1px 2px rgba(29,27,22,0.04)' }
export const serif = { fontFamily: 'var(--ns-font-serif)', fontWeight: 500, lineHeight: 1.05 }
